import { z } from "zod";
import { AssignmentKind } from "./assignmentProposal.js";

// ItemFollow: a follower's own row saying "I read this program/plan from
// its owner's partition", not a copy of it (next/coaching.md, "La SPEC del
// follower"). Stored pk=USER#<followerSub>, sk=FOLLOW#<kind>#<itemId>
// (apps/api/src/lib/ddbKeys.ts), identity-keyed like Favorite: one follow
// of a given item per person, so re-following is an idempotent Put and
// unfollowing a direct-key Delete.
//
// ⛔ No denormalised name/owner-name. Unlike AssignmentProposal (which must
// carry itemName/proposerName because the assignee cannot yet read the
// item), a follow row IS the read permission: the item resolves live from
// ownerSub's partition and its name never goes stale.
//
// CO-22 lesson: any field added after this one ships must be
// `.optional()` with a default, never required. The reader does a
// `safeParse` and `continue`s on failure, so a required new field would
// silently drop every row written before it existed.
export const ItemFollow = z.object({
  id: z.string().min(1),
  kind: AssignmentKind,
  itemId: z.string().min(1),
  // Where the real row lives. This is what makes the row a REFERENCE
  // rather than a copy.
  ownerSub: z.string().min(1),
  followerSub: z.string().min(1),
  followedAt: z.iso.datetime(),
  // Breadcrumb: which proposal this follow was born from, if any.
  sourceProposalId: z.string().min(1).optional(),
});
export type ItemFollow = z.infer<typeof ItemFollow>;
